const WALKERS = [
  { x: 33, y: 90, scale: 0.42 },
  { x: 65, y: 83, scale: 0.5 },
  { x: 185, y: 83, scale: 0.45 },
  { x: 211, y: 91, scale: 0.38 },
];

export const WinterfellNightKing = ({
  nightAmount,
}: {
  nightAmount: number;
}) => {
  /* Helpers */
  const opacity = Math.max(0, (nightAmount - 0.65) / 0.35);

  /* Render */
  const render = () => (
    <svg
      className="absolute right-0 top-[30%] h-[25%] w-[28%]"
      viewBox="0 0 250 150"
      preserveAspectRatio="xMidYMax meet"
    >
      <path
        d="M0 141 42 102 88 108 144 90 200 103 250 72V150H0Z"
        fill="var(--yard-midHill)"
      />
      <path
        d="m6 140 37-34 45 6 56-18 56 13 50-31"
        fill="none"
        stroke="var(--yard-groundTop)"
        strokeWidth="5"
      />
      <g opacity={opacity} className="transition-opacity duration-1000">
        {WALKERS.map(({ x, y, scale }) => (
          <g key={x} transform={`translate(${x} ${y}) scale(${scale})`}>
            <path d="M-7 7-12 42H12L7 7Z" fill="#33475c" />
            <circle cy="0" r="6" fill="#8198a8" />
            <path d="M-3-1H-1M1-1H3" stroke="#9deaff" strokeWidth="2" />
          </g>
        ))}
        <g transform="translate(143 56)">
          <path
            d="M-10 11-20 47-11 44-9 16M10 11 20 47 11 44 9 16"
            fill="#536f87"
          />
          <path
            d="M-10 12 0 6 10 12 15 52H-15Z"
            fill="#344e65"
            stroke="#718fa4"
            strokeWidth="1"
          />
          <path
            d="M-10 25H10M-11 32H11M-12 40H12M0 14V49"
            stroke="#68869e"
            strokeWidth="1.4"
          />
          <path
            d="M-7 2-8-10-5-7-3-17 0-9 4-17 5-6 8-11 7 2 0 8Z"
            fill="#9aafbd"
          />
          <path
            d="M-5-2H-2M2-2H5"
            stroke="#a5f3fc"
            strokeWidth="2"
            style={{ filter: "drop-shadow(0 0 3px #38bdf8)" }}
          />
          <path d="M18 4 23 51" stroke="#a0ddf4" strokeWidth="2" />
        </g>
      </g>
      <path
        d="M0 145Q90 127 150 142T250 137V150H0Z"
        fill="var(--yard-nearHill)"
      />
    </svg>
  );

  return render();
};
